/**
 * Delivery «Παραγγελίες σε Αναμονή» — localStorage-backed snapshot
 * helpers that mirror the Retail hold flow but key on a different
 * namespace.
 *
 * A held order is purely client-side until the operator resumes it
 * and presses «Καταχώρηση», at which point the standard POST
 * `/api/delivery/orders` happens. This keeps holds compatible with
 * the offline mode (operator typed items but lost connectivity) and
 * also avoids polluting the server-side daily counters with phantom
 * draft orders.
 */
const KEY = "ftext_delivery_holds_v1";
const MAX_HOLDS = 30;

export function loadHolds() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

export function saveHolds(list) {
  try {
    const trimmed = (list || []).slice(0, MAX_HOLDS);
    localStorage.setItem(KEY, JSON.stringify(trimmed));
    return trimmed;
  } catch {
    return list || [];
  }
}

export function addHold(snapshot) {
  const id = `${Date.now()}_${Math.random().toString(16).slice(2, 8)}`;
  const created_at = new Date().toISOString();
  const next = [{ id, created_at, ...snapshot }, ...loadHolds()];
  return saveHolds(next);
}

export function removeHold(id) {
  return saveHolds(loadHolds().filter((h) => h.id !== id));
}

/** Sum the cart `items[].qty * price` for the dialog's «Σύνολο» label. */
export function holdTotal(snap) {
  return (snap?.items || []).reduce(
    (s, it) => s + Number(it.qty || 1) * (Number(it.price || 0) + Number(it.modifier_total || 0)),
    0,
  );
}
